import { Button, Dialog, DialogActions, DialogContent, DialogTitle, FormControl, Grid, InputLabel, MenuItem, OutlinedInput, Select, SelectChangeEvent, TextField } from "@mui/material";
import { useEffect, useState } from "react";
import { Roles, User } from "../../../common";

const UserDetailsModal = ({ user, isOpen, close, save }: {
    user: User,
    isOpen: boolean,
    close: () => void,
    save: (user: User) => void
}) => {
    const [open, setOpen] = useState<boolean>(isOpen);
    const [username, setUsername] = useState<string>(user.username);
    const [roles, setRoles] = useState<string[]>(user.roles);

    const roleNames = [
        Roles.FormsAdmin,
        Roles.UserAdmin,
        Roles.OfflineUser,
        Roles.FormSubmissionViewer,
        Roles.WelcomeBoard
    ];

    useEffect(() => {
        reset();
        setOpen(isOpen);
    }, [isOpen]);

    const handleCancel = () => {
        close();
        reset();
    };

    const handleOk = () => {
        user.username = username;
        user.roles = roles;

        save(user);
        close();
    }

    function reset(): void {
        setUsername(user.username);
        setRoles(user.roles);
    }

    const handleRolesChange = (event: SelectChangeEvent<typeof roles>) => {
        const {
            target: { value },
        } = event;
        setRoles(
            // On autofill we get a stringified value.
            typeof value === 'string' ? value.split(',') : value,
        );
    }

        return (
            <Dialog
                open={open}
                fullWidth
                maxWidth="sm"
            >
                <DialogTitle>User Details</DialogTitle>
                <DialogContent>
                    <Grid container spacing={3} direction="row" justifyContent="space-between" alignItems="center" style={{ paddingTop: '10px' }}>
                        <Grid item xs={12}>
                            <TextField
                                id="username"
                                label="Username"
                                fullWidth
                                required
                                value={username}
                                onChange={(e) => setUsername(e.target.value)}
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <FormControl fullWidth>
                                <InputLabel id="roles-label">Roles</InputLabel>
                                <Select
                                    labelId="roles-label"
                                    id="roles-select"
                                    multiple
                                    value={roles}
                                    onChange={handleRolesChange}
                                    input={<OutlinedInput label="Name" />}
                                >
                                    {roleNames.map((name) => (
                                        <MenuItem
                                            key={name}
                                            value={name}
                                        >
                                            {name}
                                        </MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                        </Grid>
                    </Grid>
                </DialogContent>
                <DialogActions>
                    <Button autoFocus onClick={handleCancel}>
                        Cancel
                    </Button>
                    <Button onClick={handleOk}>Ok</Button>
                </DialogActions>
            </Dialog>
        );

    };

    export default UserDetailsModal;